@use '../../../../app/styles/common/mixins';

.offerOwner {
  display: flex;
  flex-direction: row;
  gap: var(--spasing16);
  align-items: flex-start;
  justify-content: space-between;

  &.withLinks {
    .name {
      @include mixins.typographyCommon;
    }
  }

  &.variant-short {
    .info {
      gap: var(--spasing04);

      .link {
        gap: var(--spasing02);

        svg {
          width: 16px;
          height: 16px;
          min-width: 16px;
          min-height: 16px;
        }
      }

      .name {
        @include mixins.heading-primary-300;
      }

      .offersCount {
        font-size: 14px;
        line-height: 17px;
        color: var(--fg-primary);
      }

      // Keep the desktop short layout uniform (rows 4px apart) after the
      // `.meta` wrapper was introduced for the mobile default variant.
      .meta {
        gap: var(--spasing04);
      }
    }

    .avatar .image {
      width: 48px;
      height: 48px;
    }
  }

  // Mobile seller block (rendered only via SellerDetails behind the isMobile guard)
  &.variant-default {
    .info {
      .nameRow {
        display: flex;
        align-items: center;
        gap: var(--spasing06);
        min-width: 0;
      }

      .name {
        flex: 0 1 auto;
        min-width: 0;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .online {
        flex: 0 0 auto;

        @include mixins.heading-primary-400;
      }

      // The ProfileLinkWrapper sits between `.info` and `.nameRow`; without
      // min-width:0 its automatic min size equals the (now nowrap) full name
      // width, so it refuses to shrink and pushes the chevron off the edge.
      .link {
        min-width: 0;

        // Keep the trailing chevron visible when the name truncates
        svg {
          flex: 0 0 auto;
        }
      }

      .meta {
        gap: var(--spasing06); // between meta rows
      }

      .rating {
        .rate,
        .reviewsCount {
          @include mixins.heading-secondary-200;
        }
      }

      .offersCount {
        @include mixins.body-primary-400;
      }

      .registeredDate {
        color: var(--fg-secondary);

        @include mixins.body-primary-400;
      }
    }

    .avatar {
      .image {
        width: 60px;
        height: 60px;
      }

      &.avatarOnline::after {
        width: 8px;
        height: 8px;
        top: 4px;
        right: 4px;
      }
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: var(--spasing08);

    flex: 1 1 auto;
    overflow: hidden;

    .nameRow {
      display: inline-flex;
      align-items: baseline;
      gap: var(--spasing04);
    }

    .name {
      color: var(--fg-primary);

      @include mixins.line-clamp(1, ellipsis);
      @include mixins.heading-primary-400;

      @include mixins.laptop {
        @include mixins.heading-primary-500;
      }
    }

    .online {
      color: var(--fg-success);

      @include mixins.heading-primary-300;
    }

    .responseTime {
      color: var(--fg-secondary);

      @include mixins.caption-primary-450;
    }

    .meta {
      display: flex;
      flex-direction: column;
      gap: var(--spasing06);
    }

    .rating {
      gap: var(--spasing06);

      .rate {
        @include mixins.caption-primary-500;
      }

      .reviewsCount {
        color: var(--fg-primary);

        @include mixins.caption-primary-500;
      }
    }

    .offersCount {
      font-size: 16px;
      line-height: 28px;

      @include mixins.tablet {
        font-size: 18px;
      }
    }

    .registeredDate {
      color: var(--fg-secondary);
      font-size: 16px;
      line-height: 28px;

      @include mixins.tablet {
        font-size: 18px;
      }
    }
  }

  .avatar {
    display: flex;
    flex: 0 0 auto;
    position: relative;

    .image {
      display: block;
      border-radius: 50%;
      object-fit: cover;

      width: 92px;
      height: 92px;
    }

    // Online indicator dot — green circle with white outline at the avatar's
    // top-right corner, matching Figma's ellipse placement.
    &.avatarOnline::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: var(--bg-success);
      box-shadow: 0 0 0 2px var(--surface-01);
    }
  }
}
